import { Money } from './AdminUi'

const labels: Record<string, string> = {
  workspace_id: 'Workspace', plan_id: 'Plano', plan_code: 'Plano',
  from_plan: 'Plano atual', to_plan: 'Plano concedido', days: 'Duração',
  current_period_end: 'Vencimento atual', current_period_start: 'Início do período',
  current_price_cents: 'Preço atual', new_price_cents: 'Novo preço mensal',
  target_price_cents: 'Preço mensal de destino', price_cents: 'Preço mensal',
  legacy_subscriptions: 'Assinaturas com preço antigo', candidate_count: 'Assinaturas a migrar',
  current: 'Antes', updated: 'Depois', local: 'Dados locais', remote: 'Dados da Stripe',
  name: 'Nome', description: 'Descrição', max_projects: 'Limite de projetos', max_members: 'Limite de membros',
  allow_version_history: 'Histórico de versões', allow_team_members: 'Membros no workspace',
  allow_export_import: 'Importação e exportação', is_available_for_purchase: 'Disponível para compra', is_active: 'Disponível',
  user_id: 'Usuário', email: 'E-mail', already_verified: 'E-mail já verificado',
  status: 'Status', cancel_at_period_end: 'Encerrar no vencimento', current_plan: 'Plano atual',
  pending_plan: 'Plano agendado', scheduled_change_at: 'Data da mudança', contract: 'Contrato',
}

const values: Record<string, string> = {
  free: 'Gratuito', pro: 'Pro', team: 'Team', active: 'Ativo', trialing: 'Acesso temporário',
  canceled: 'Cancelado', past_due: 'Pagamento pendente',
}

export function AdminActionSummary({ snapshot }: { snapshot: Record<string, unknown> }) {
  return <div className="space-y-3 rounded-xl border p-4" style={{ borderColor: 'var(--border)', background: 'var(--bg-toolbar)' }}>
    {snapshot.to_plan ? <p className="text-sm font-semibold" style={{ color: 'var(--accent)' }}>Acesso gratuito · sem cobrança</p> : null}
    <dl className="space-y-3">{Object.entries(snapshot).filter(([key]) => labels[key]).map(([key, value]) =>
      <div key={key} className={value && typeof value === 'object' ? '' : 'flex items-start justify-between gap-4 text-xs'}>
        <dt style={{ color: 'var(--text-muted)' }}>{labels[key]}</dt>
        <dd className="font-medium">{value && typeof value === 'object' && !Array.isArray(value)
          ? <div className="mt-2"><AdminActionSummary snapshot={value as Record<string, unknown>} /></div>
          : value === null || value === undefined ? '—'
          : key.endsWith('_cents') ? <Money cents={Number(value)} />
          : key === 'days' ? `${value} dias`
          : typeof value === 'boolean' ? value ? 'Sim' : 'Não'
          : /(_at|period_end|period_start)$/.test(key) ? new Date(String(value)).toLocaleString('pt-BR')
          : values[String(value)] ?? String(value)}</dd>
      </div>,
    )}</dl>
    {snapshot.to_plan && snapshot.current_period_end ? <p className="text-xs" style={{ color: 'var(--text-muted)' }}>Os dias serão acrescentados a partir do vencimento atual ou de hoje, se o acesso já venceu.</p> : null}
  </div>
}
